import { Component, Input } from '@angular/core';
import { ProductGrade } from '@app/core/interfaces/product-grade';

@Component({
    selector: 'ins-product-grade-hand',
    templateUrl: './product-grade-hand.component.html',
    exportAs: 'ins-product-grade-hand',
})

export class ProductGradeHandComponent {
    @Input() productGrade: ProductGrade;
}
